export const CLOUD_RETAIL = {
  EVENTS: {
    CTA_ADD_TO_CART: 'add-to-cart',
    PAGE_CART: 'shopping-cart-page-view',
    PAGE_CHECKOUT_CONFIRM: 'purchase-complete',
    PAGE_HOME: 'home-page-view',
    PAGE_PRODUCT: 'detail-page-view',
    PAGE_PRODUCTS: 'category-page-view',
    PAGE_SEARCH: 'search',
  },
};

export const TAG_MANAGER = {
  EVENTS: {
    CTA_ADD_CART: 'Création Panier',
    CTA_ADD_TO_CART: 'CTA Ajouter Panier',
    CTA_ADD_WISHLIST: 'Création Liste Achat',
    CTA_ADD_WORKSITE: 'Création Chantier',
    CTA_COOKIE_CONSENT: 'Cookie Consent',
    CTA_DOWNLOAD_DOCUMENT: 'Télécharger Documentation',
    CTA_DOWNLOAD_INSTALLER: 'Téléchargement PDF Devis Installateur',
    CTA_DOWNLOAD_QUOTE: 'Téléchargement PDF Devis',
    CTA_GENERATE_INSTALLER: 'Génération Devis Installateur',
    CTA_LOGIN: 'Connexion Compte',
    CTA_PRICE_REQUEST: 'Demande Fichier Tarif',
    CTA_REGISTER: 'Création Compte',
    CTA_VALIDATE_CART: 'Validation Panier',
    CTA_VALIDATE_DRAFT: 'Demande Devis envoyée',
    PAGE_CART: 'CTA Panier',
    PAGE_CHECKOUT_CONFIRM: 'Validation Commande',
    PAGE_ECATALOG: 'E-Catalogue',
    PAGE_HOME: 'Page Accueil',
    PAGE_PRODUCT: 'Page Produit',
    PAGE_PRODUCTS: 'Descente Catalogue',
    PAGE_SEARCH: 'Recherche',
  },
  ORIGINS: {
    CONFIG_PRODUCTS: 'Tableau des configurations',
    DRAFT: 'Devis Brouillon',
    ECATALOG: 'E-Catalogue',
    LAST_VIEWED: 'Dernier vus',
    ORDER: 'Commande',
    PRODUCT: 'Fiche Produit',
    PRODUCTS: 'Descente Catalogue',
    QUICK_ENTRY_CART: 'Saisie Rapide Panier',
    QUOTE: 'Devis',
    SEARCH: 'Recherche',
    SUGGEST: 'Suggestion IA',
    TOP_PRODUCTS: 'Palmarès',
    UNDEFINED: 'Inconnue',
    WISHLIST: 'Liste Achat',
  },
};
